/*
 * Constants for route names so they can be shared throughout the app
 */
export const MARKING_TASKS = 'Marking Tasks';
